import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/logo24.png";
import { Link } from "react-router-dom";
import "./Styles.css";

export default function Navbar({ sectionsRef }) {
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="container mt-3">
      <nav className="navbar navbar-expand-lg px-4 py-3 custom-navbar">
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img
            src={logo}
            alt="logo"
            className="logo-img"
            style={{ width: "48px", height: "48px" }}
          />

          <div className="ms-2 d-flex flex-column">
            <span className="fw-semibold text-white brand-title">Neomonks</span>
            <span className="text-muted small">Tech Pvt Ltd.</span>
          </div>
        </a>

        {/* TOGGLER */}
        <button
          className="navbar-toggler text-white"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navLinks"
        >
          <span className="navbar-toggler-icon" />
        </button>

        {/* NAV LINKS */}
        <div
          className="collapse navbar-collapse justify-content-center"
          id="navLinks"
        >
          <ul className="navbar-nav gap-lg-5 text-center nav-center">
            <li className="nav-item">
              <Link to="/" className="nav-link custom-link">
                Home
              </Link>
            </li>

            <li className="nav-item">
              {/* <button
                className="nav-link custom-link"
                onClick={() => scrollToSection(sectionsRef.getInTouch)}
              >
                Products
              </button> */}
              <Link to="/products" className="nav-link custom-link">
                Products
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/technology" className="nav-link custom-link">
                Technology
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/about-us" className="nav-link custom-link">
                About Us
              </Link>
            </li>

            {/* <li className="nav-item">
              <button className="nav-link custom-link">
                Careers
              </button>
            </li>

            <li className="nav-item">
              <button className="nav-link custom-link">
                Blog
              </button>
            </li> */}
          </ul>
        </div>

        {/* RIGHT BUTTON */}
        <div className="d-none d-lg-block">
          <Link to="/reach-us" className="contact-btn">
            Contact Us
          </Link>
        </div>
      </nav>
    </div>
  );
}
